class CteUploadXmlModal {
    constructor(gql, scope) {
        this.gql = gql
        this.apply = (fn) => scope.$apply(fn)
    }

    submit() {
        if (this.form && this.form.$valid) {
            this.upload()
        }
    }

    async upload() {
        const query = gql`
            mutation ImportCteXml($empresaId: String!, $filialId: Int!, $xml: Upload!) {
                empresa(id: $empresaId) {
                    cte: importCte(xml: $xml, filialId: $filialId) {
                        id
                    }
                }
            }
        `
        const uploadProgress = (e) => {
            this.apply(() => this.progress = (e.loaded / e.total) * 100)
        }

        const variables = { empresaId: this.resolve.contratoId.toString(), filialId: parseInt(this.empresa.id), xml: this.xml }

        try {
            await this.gql
                .mutate(query, variables, { context: { uploadProgress } })
                .then(({ empresa: { cte } }) => {
                    Alert.success("Arquivo importado com sucesso!", "Sucesso")
                    return cte
                })

            this.close()
        } catch (errors) {
            let [error] = errors

            this.apply(() => {
                this.progress = 0
                this.error = this.getErrorMessage(error.message)
            })
        }
    }

    getErrorMessage(error) {
        switch (error) {
            case "invalid_file":
                return "O arquivo enviado não é um XML."
            case "invalid_xml":
                return "O arquivo XML enviado não é um CT-e válido."
            case "invalid_cte":
                return "O arquivo XML não atende ao formato exigido pela RFB."
            case "unsupported_version":
                return "Versão do XML não suportada."
            case "filial_divergente":
                return "A filial selecionada não foi identificada como participante do CT-e."
        }
    }
}

angular.module('eficienciaFiscalModule')
    .component('cteUploadXmlModal', {
        controller: ['gql', '$scope', CteUploadXmlModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
            <modal title="Enviar CT-e" close="$ctrl.close">
                <modal-body>
                    <ef-empresa-selector
                        name="empresaId" required
                        ng-model="$ctrl.empresa"
                        contrato-id="$ctrl.resolve.contratoId"
                        cache-as="cte-upload">
                    </ef-empresa-selector>
                    <div class="form-group">
                        <label>Arquivo XML</label>
                        <input class="btn btn-default btn-block" ngf-select type="file" name="xml" ng-model="$ctrl.xml" required>
                        <div ng-messages="form.xml.$error" ng-messages-multiple ng-messages-include="erros-validacao" ng-if="form.$submitted"></div>
                    </div>
                    <highlighted ng-show="$ctrl.error">
                        <main>Ocorreu um erro na importação.</main>
                        <secondary class="text-danger">{{ $ctrl.error }}</secondary>
                    </highlighted>
                    <div class="progress" ng-class="{'progress-striped active': $ctrl.progress == 100}" ng-show="$ctrl.progress > 0">
                        <div class="progress-bar bg-color-blue" role='progressbar' ng-style="{ 'width': $ctrl.progress + '%' }"></div>
                    </div>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-primary" type="submit">Enviar</button>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        </form>
        `
    })
